import { render, staticRenderFns } from "./SegmentsColumn.vue?vue&type=template&id=3f401556&scoped=true"
import script from "./SegmentsColumn.vue?vue&type=script&lang=js"
export * from "./SegmentsColumn.vue?vue&type=script&lang=js"
import style0 from "./SegmentsColumn.vue?vue&type=style&index=0&id=3f401556&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f401556",
  null
  
)

export default component.exports